import BaseController from "./base_controller"

class FileUploadController extends BaseController {
  connect() {
    this.attrs = this.getAttributes()
    this.attrs.name || alert('No name given')

    const node = $(this.element)
    const css = {
      'border-radius': '5px',
      width: '120px',
      height: '120px',
      cursor: 'pointer',
      position: 'relative'
    }

    node.addClass('hover-toggle')

    if (this.attrs.image) {
      node.css({...css,
        background: `url(${this.attrs.image})`,
        'background-size': 'cover'
      })

      node.append(this.closeButton())
    } else {
      node.css({
        ...css,
        'background-color': '#eee',
        padding: '10px',
        overflow: 'hidden',
        border: '1px solid #ccc'
      })
      this.element.innerHTML = this.attrs.title || 'Add file'
    }

    // load Dropzone if not loaded and continue
    if (window.Dropzone) {
      this.connectDropzone()
    } else {
      $.getScript(
        'https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.3/dropzone.min.js',
        this.connectDropzone.bind(this)
      )
    }
  }

  connectDropzone() {
    new Dropzone(this.element, {
      maxFiles: parseInt(this.attrs.max) || 1,     // max number of files
      maxFilesize: parseInt(this.attrs.size) || 5, // max file size in MB
      paramName: this.attrs.name,
      url: this.attrs.path,
      headers: {
       'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      },
      init: function() {
        this.on('success', function() {
          $('body').reload()
        })

        this.on('maxfilesexceeded', function(file) {
          this.removeAllFiles()
          this.addFile(file)
        });

        this.on('complete', function() {
        });
      },
    });
  }

  closeButton() {
    return `
      <span
        class="hover-show"
        style="
          position: absolute;
          bottom: 5px; right: 5px;
          background-color: #eee;
          border: 1px solid #ccc;
          border-radius: 3px;
          padding: 0 5px;
          line-height: 20px;
          color: red;"
        onclick="Api('${this.attrs.path}', {'${this.attrs.name}': ''}).reload()"
        >&times;</span>`
  }
}

export default FileUploadController
